import React, { useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AddBusiness } from '@mui/icons-material';
import { Button, Box, Typography } from '@mui/material';
import { adminsPathTo } from '../utils/Api';
import { UserContext } from '../contexts/UserContext';
const ControlCenter = () => {
  const [accountList, setAccountList] = React.useState([]);
  const navigate = useNavigate();
  const { currentUser, setCurrentUser } = useContext(UserContext);

  const handleNavigate = (path) => {
    navigate(path);
  }

  const handleAccessAccount = (account) => {
    adminsPathTo.access_account({account_id: account.id}).then(result => {
      setCurrentUser({...currentUser, provider_id: account.provider_id});
    })
  }

  const handleClearProvider = () => {
    adminsPathTo.clear_access_account().then(result => {
      setCurrentUser({...currentUser, provider_id: null});
    })
  }

  useEffect(() => {
    adminsPathTo.listProvidersAccount().then(result => {
      if (result.status === 403) {
        navigate('/login');
      }
      setAccountList(result.data);
    });
  }, [ navigate ]);

  return (
    <Box>
      <Typography variant="h4" color="primary">
        Control Center
      </Typography>

      <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Button
          onClick={() => handleNavigate('/new-provider')} 
          sx={{ mt: 2, mb: 2 }} variant="contained">
          <AddBusiness />
        </Button>
        <Button color="primary" variant="outlined" onClick={() => handleNavigate('/control-center/campaigns')}>Campanhas</Button>
        <Button color="primary" variant="outlined" onClick={() => handleNavigate('/control-center/coupons')}>Cupons</Button>
        <Button color="primary" variant="outlined" onClick={() => handleClearProvider()}>Limpar fornecedor</Button>
      </Box>

      <Typography variant="h5" color="primary">
        Acessar Fornecedor
      </Typography>
      <table>
        <tbody>
          <tr>
            <th>Nome</th>
            <th>Telefone</th>
          </tr>
          {accountList.map((account) => (
            <tr key={account.id}>
              <td>{account.email}</td>
              <td>
                <Button color="primary" variant="outlined" onClick={() => handleAccessAccount(account)}>Acessar</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  )
}

export default ControlCenter
